// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1IYwk","footer":"ModalUpdate_footer__-YUVg"};